import {
  useCrearCodigoPokemon,
  useEditarLogro,
  useListarCodigosPokemon,
  useListarPokemones
} from "../../../../Hooks/Admin";
import { CustomForm } from "../../../../Components/Admin/CustomForm";
import { CustomTable } from "../../../../Components/Admin/CustomTable";
import {
  camposFormulario,
  columns,
  formatData,
  camposFilter,
} from "./camposFormulario";
import { useEffect, useState } from "react";

export const CodigosPokemonForm = () => {
  const [campos, setCampos] = useState(camposFormulario([]));
  const initialValues = {
    cantidad: 1,
  };
  const queryListarPokemones = useListarPokemones([]);

  useEffect(() => {
    if (queryListarPokemones.isSuccess) {
      setCampos(camposFormulario(queryListarPokemones.data));
    }
  }, [queryListarPokemones.isSuccess]);

  return (
    <>
      {campos && (
        <CustomForm
          camposFormulario={campos}
          querySubmit={useCrearCodigoPokemon}
          initialValues={initialValues}
        />
      )}
    </>
  );
};

export const CodigosPokemonEditar = () => {
  const [campos, setCampos] = useState(camposFilter([]));
  
  const initialValues = {
    mostrarTodos: 0,
  };

  useEffect(() => {
    const estados = [
      {
        label: "Activos",
        value: 0,
      },
      {
        label: "Mostrar Todo",
        value: 1,
      },
    ];
    setCampos(camposFilter(estados));
  }, []);

  return (
    <CustomTable
      camposFilter={campos}
      queryListar={useListarCodigosPokemon}
      initialValues={initialValues}
      columns={columns}
    />
  );
};
